import { render } from "./AdminLibraryPage.vue?vue&type=template&id=0b51994d"
import script from "./AdminLibraryPage.vue?vue&type=script&lang=js"
export * from "./AdminLibraryPage.vue?vue&type=script&lang=js"

import "./AdminLibraryPage.vue?vue&type=style&index=0&id=0b51994d&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__